import toNumber from 'lodash/toNumber';

const { REACT_APP_COOKIES_REFRESH_PERIOD: period } = process.env;

export const useRefreshAnalyticsPeriod = (): number => {
  const defaultPeriod = 90;

  return toNumber(period) || defaultPeriod;
};
